<div
  class="qaroni-bg-surface item-container flex w-full items-center justify-between gap-3 overflow-x-auto rounded-lg border p-3 md:gap-5 md:p-5">
  @if (file()) {
    <div class="hidden items-center text-primary-60 md:flex">
      <mat-icon class="qaroni-mat-icon-32">{{
        file()?.name | typeFilesIcons
      }}</mat-icon>
    </div>
    <div class="flex flex-1 flex-col gap-2">
      <div class="flex w-full flex-row items-center leading-none">
        <span class="font-medium leading-none">{{
          file()?.name | fileNameTruncate
        }}</span>
        <span
          class="mx-2 shrink-0 text-xs font-light leading-none text-neutral-70"
          >{{ file()?.size | fileSize }}</span
        >
      </div>
      <mat-progress-bar
        color="primary"
        [mode]="progressBarMode"
        [value]="file()?.progress" />
    </div>
    <div class="flex h-full items-center">
      <button
        mat-mini-fab
        color="none"
        class="qaroni-mat-mini-fab-size mat-elevation-z0"
        type="button"
        (click)="onDeleteFile()"
        [disabled]="!uploadComplete">
        <mat-icon class="qaroni-mat-icon-18" color="warn">cancel</mat-icon>
      </button>
    </div>
  } @else {}
</div>
